import { render, staticRenderFns } from "./bdmProfile.vue?vue&type=template&id=3ac0a3ae&scoped=true&"
import script from "./bdmProfile.vue?vue&type=script&lang=js&"
export * from "./bdmProfile.vue?vue&type=script&lang=js&"
import style0 from "./bdmProfile.vue?vue&type=style&index=0&id=3ac0a3ae&prod&scoped=true&lang=css&"
import style1 from "./bdmProfile.vue?vue&type=style&index=1&id=3ac0a3ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac0a3ae",
  null
  
)

export default component.exports